import styles from './AgentSuggestionsIndicator.module.css'

type AgentSuggestionsIndicatorProps = {
  count: number
}

export const AgentSuggestionsIndicator = ({count}: AgentSuggestionsIndicatorProps) => {
  if (count <= 0) return null

  const label = `${count} pending suggestion${count === 1 ? '' : 's'}`

  return (
    <span className={styles.container}>
      <span> &middot; </span>
      <span>{label}</span>
    </span>
  )
}
